import { useMemo } from "react";
import { useSelector } from "react-redux";

export function useSkillExceptions(skillId) {
  const exceptions = useSelector(state => state.Periods.exceptions)

  return useMemo(
    () => exceptions?.[skillId]?.map(([startAt, endAt]) => [new Date(startAt), new Date(endAt)]) ?? [],
    [exceptions, skillId]
  )
}
